module.exports = __webpack_public_path__ + "static/comingSoonHeaderNew-d9104149bc96d5d6b04043b291239fbe.png";